function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTetrahedron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.986 2.5a.5.5 0 0 0-.369.178l-8 9.5a.5.5 0 0 0 .137.76l8 4.5a.5.5 0 0 0 .492 0l8-4.5a.5.5 0 0 0 .137-.76l-8-9.5a.5.5 0 0 0-.397-.178zM9.5 4.371v11.774l-6.729-3.786L9.5 4.371zm1 0 6.729 7.988-6.729 3.786V4.37z",
    style: {
      fill: "#222",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0
    },
    id: "layer1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetrahedron);
export default __webpack_public_path__ + "static/media/tetrahedron.b80b40e5f5c54e53814a5d2989f96a6e.svg";
export { ForwardRef as ReactComponent };